import React from 'react';
import { SentimentSatisfied } from '@material-ui/icons';
import { Picker } from 'emoji-mart';

import useClickOutside from '../../../hooks/useClickOutside';


const BroadcastChatInputEmoticonPicker = ({
  emoticonsPickerVisible,
  onEmoticonClick,
  toggleEmoticonsPicker,
}) => {
  const emoticonsRef = React.useRef(null);
  useClickOutside(emoticonsRef, () => {
    toggleEmoticonsPicker(false);
  });

  return (
    <div ref={emoticonsRef} className="emoticons">
      <div className="emoticons-picker-toggle">
        <SentimentSatisfied
          fontSize="large"
          onClick={() => toggleEmoticonsPicker(!emoticonsPickerVisible)}
        />
      </div>
      <div
        className="emoticons-picker-container"
        style={!emoticonsPickerVisible ? { display: 'none' } : null}
      >
        <Picker exclude={'flags'} onSelect={onEmoticonClick} />
      </div>
    </div>
  );
};

export default BroadcastChatInputEmoticonPicker;
